import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { defaultNoteListConfig, kirokuNoteListConfigs, storageChangeKey, timeFormat, unitOfSpan, unitOfTime } from '@app/basic/note-list/config';
import { KirokuSetting } from '@app/models/record-settig.model';
import { KirokuMenu, MENU_KIDS, RecordTagSet, RecordTitle, RecordTitleSet } from '@app/models/record.model';
import { User } from '@app/models/user.model';
import { UserService } from '@app/services/dai.service';
import { OfficeService } from '@app/services/office.service';
import { StaffService } from '@app/services/staff.service';
import { WebviewService } from '@app/services/webview.service';
import { StorageEnum } from '@app/shared/enum/storage';
import { AuthSelectors } from '@app/store/auth/auth.selectors';
import { SetStaffInTeamList, SetUserInGroupList } from '@app/store/data/data.classes';
import { CancelHandler } from '@app/store/modal/modal.classes';
import { SetKirokuSetting } from '@app/store/record/record.classes';
import { RecordSelectors } from '@app/store/record/record.selectors';
import { TriggerHistory } from '@app/store/schedule/schedule.classes';
import { SettingSelectors } from '@app/store/setting/setting.selectors';
import { Select, Store } from '@ngxs/store';
import * as moment from 'moment';
import { filter, fromEvent, Observable, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-record-display-setting',
  templateUrl: './record-display-setting.component.html',
  styleUrls: ['./record-display-setting.component.scss'],
})
export class RecordDisplaySettingComponent implements OnInit, OnDestroy, AfterViewInit {
  @Select(SettingSelectors.titleTagList) titlelist$!: Observable<RecordTitleSet[]>;
  onDestory$: Subject<void>;
  form!: FormGroup;
  settingLocalStorage: any = null;
  conditionFilterStorage: any = {};
  isPersonal: boolean = false;
  displaySettingDate: any = [];
  teamList: any[] = [];
  isClear: boolean = false;
  // filter data section
  _daicds: string[] = [];
  _staffcds: string[] = [];
  // kiroku tag
  kirokuTagList: RecordTagSet[] = [];
  // chouhyo tag
  chouhyoTagList: RecordTagSet[] = [];
  _config!: KirokuSetting;
  // getter - setter
  get isKIROKUKENSAKU() {
    return this.currentMenu === KirokuMenu.KIROKUKENSAKU;
  }
  get isKirokuOnly() {
    return localStorage.getItem(StorageEnum.MENU) === MENU_KIDS.KIROKU;
  }
  get isAredasite() {
    return localStorage.getItem('menu') === MENU_KIDS.AREDASITE;
  }
  get currentMenu(): string {
    return localStorage.getItem(StorageEnum.MENU_ITEM) || KirokuMenu.EMPTY;
  }
  get menuConfig() {
    return kirokuNoteListConfigs.find(x => x.type === this.currentMenu) || defaultNoteListConfig;
  }
  get objectcd() {
    return this.store.selectSnapshot(AuthSelectors.objectcd) || localStorage.getItem('objectcd') || '';
  }
  get titleTagList(): RecordTagSet[] {
    return this.store.selectSnapshot(SettingSelectors.titleTagList);
  }
  get userList() {
    return this.daiService.userList;
  }
  get staffList() {
    return this.staffService.staffList;
  }
  get profile() {
    return this.store.selectSnapshot(AuthSelectors.profile);
  }
  get stateConfig(): KirokuSetting {
    return this.store.selectSnapshot(RecordSelectors.kirokuSetting);
  }
  get userForm() {
    return this.form.get('daicd') as FormControl;
  }

  get staffForm() {
    return this.form.get('staffCd') as FormControl;
  }

  get keyword() {
    return this.form?.get('keyword') as FormControl;
  }

  get dateRange() {
    return this.form?.get('dateRange') as FormGroup;
  }

  get startDate() {
    return this.dateRange.get('sdate') as FormControl;
  }

  get endDate() {
    return this.dateRange.get('edate') as FormControl;
  }

  get pickupflg() {
    return this.form.get('pickupflg') as FormControl;
  }

  get selectedAllKiroku() {
    return this.currentTitleState('kirokuTag');
  }
  get selectedAllChouhyo() {
    return this.currentTitleState('chouhyoTag');
  }
  set selectedAllKiroku(value) {
    this.setCurrentTitleState(value, 'kirokuTag');
  }
  set selectedAllChouhyo(value) {
    this.setCurrentTitleState(value, 'chouhyoTag');
  }
  get titleList(): RecordTagSet[] {
    const titleList = this.store.selectSnapshot(SettingSelectors.titleSetList);
    return titleList.map(item => ({ 
      ...item, 
      ttl_kbntag: item.ttlnm,
      titles: item.titles.map(title => ({
        ...title,
        ttl_kbntag: title.ttlnm,
        ttltag: title.ttlnm,
      }))
    }));
  }

  constructor(
    private daiService: UserService,
    private staffService: StaffService,
    private officeService: OfficeService,
    private router: Router,
    private fb: FormBuilder,
    private store: Store,
    private cdr: ChangeDetectorRef,
    private webviewService: WebviewService
  ) {
    this.onDestory$ = new Subject();
    const objectcd = this.officeService.officecd;
    this.store.dispatch(
      [
        new SetUserInGroupList(objectcd),
        new SetStaffInTeamList(objectcd)
      ]);
  }


  ngAfterViewInit(): void {
    let accordBody = document.querySelector('.custom-kids')?.querySelector('.mat-expansion-panel-body');
    if (accordBody) {
      (accordBody as HTMLElement).style.padding = '1rem 0';
    }
  }
  ngOnDestroy(): void {
    this.onDestory$.next();
  }

  currentTitleState(tagName: string) {
    const data = this.form?.get(tagName) as FormArray;
    if (data) {
      return data.value.every((g: boolean[]) => g.every(a => a)) || false
    }
    return false
  }

  setCurrentTitleState(value: boolean, tagName: string) {
    const data = this.form?.get(tagName) as FormArray;
    if (data) {
      const newData = data.value.map((g: boolean[]) => g.map(() => value));
      data.patchValue(newData);
    }
  }

  ngOnInit(): void {
    fromEvent<StorageEvent>(window, 'storage')
      .pipe(
        filter((x: StorageEvent) => storageChangeKey.some(key => key === x.key)),
        takeUntil(this.onDestory$)
      ).subscribe(() => this.close());
    this.titlelist$.pipe(takeUntil(this.onDestory$)).subscribe(() => {
      this._config = { ...this.stateConfig };
      this.initTitleTag();
      this.applyConfig()
    });
    this.cdr.detectChanges();
  }

  onSelectedKirokuAll() {
    this.selectedAllKiroku = !this.selectedAllKiroku;
  }
  onSelectedChouhyoAll() {
    this.selectedAllChouhyo = !this.selectedAllChouhyo;
  }

  initTitleTag() {
    this.kirokuTagList = [...this.titleList];
  }

  initSelectedCondition(titles: RecordTitle[], ttl_kbntag?: string) {
    const { ttl, isInit } = this._config;
    const { tags } = this.menuConfig;
    if (this.isClear) return titles.map(() => false);
    if (isInit && tags?.length) {
      const kbntags = ttl_kbntag?.replace(/#/g, '');
      return titles.map((t: any) => tags.some(tt => {
        const tags = t.ttltag?.replace(/#/g, '');
        return kbntags === tt || tags === tt
      }));
    }
    return titles.map(t => (ttl || []).some(tt => tt === t.ttlkbn + '-' + t.ttlcd))

  }

  emptyConfig() {
    // using if clear once
    this._daicds = [];
    this._staffcds = [];
    this.getUser = getUser(this.userList);
    const _sdate = moment(new Date()).startOf(unitOfTime).toDate();
    const _edate = moment(new Date()).endOf(unitOfTime).toDate();
    const groupsKiroru = this.kirokuTagList.map(x => this.initSelectedCondition(x.titles, x.ttl_kbntag));
    this.selectedAllKiroku = groupsKiroru.every(x => x.every(tt => tt));
    const groupsChouhyo = this.chouhyoTagList.map(x => this.initSelectedCondition(x.titles, x.ttl_kbntag));
    this.selectedAllChouhyo = groupsChouhyo.every(x => x.every(tt => tt));
    this.form = this.fb.group({
      dateRange: this.fb.group({ sdate: _sdate, edate: _edate }),
      staffCd: [],
      keyword: '',
      pickupflg: false,
      summary: false,
      kirokuTag: this.fb.array(groupsKiroru.map((g: boolean[]) => this.fb.array(g))),
      chouhyoTag: this.fb.array(groupsChouhyo.map((g: boolean[]) => this.fb.array(g))),
    });

  }

  applyConfig() {
    const { daicds, sdate, edate, pickupflg, stfcds, keyword, screen } = this._config;
    this._daicds = daicds || [];
    this.getUser = getUser(this.userList);
    const _sdate = moment(sdate || new Date()).startOf(unitOfTime).toDate();
    const _edate = moment(edate || new Date()).endOf(unitOfTime).toDate();
    const stfs = stfcds || [];
    const additionalStf = KirokuMenu.JIBUNGAIRETA === screen ? [this.profile?.staffCode || ''] : [];
    this._staffcds = [...additionalStf, ...stfs];
    // tags grouping
    const groupsKiroru = this.kirokuTagList.map(x => this.initSelectedCondition(x.titles, x.ttl_kbntag));
    this.selectedAllKiroku = groupsKiroru.every(x => x.every(tt => tt));
    const groupsChouhyo = this.chouhyoTagList.map(x => this.initSelectedCondition(x.titles, x.ttl_kbntag));
    this.selectedAllChouhyo = groupsChouhyo.every(x => x.every(tt => tt));
    this.form = this.fb.group({
      dateRange: this.fb.group({ sdate: _sdate, edate: _edate }),
      staffCd: [],
      keyword: keyword?.join(' ') || '',
      pickupflg: Boolean(pickupflg),
      summary: false,
      kirokuTag: this.fb.array(groupsKiroru.map((g: boolean[]) => this.fb.array(g))),
      chouhyoTag: this.fb.array(groupsChouhyo.map((g: boolean[]) => this.fb.array(g))),
    });
  }

  changeUserFilter(dais: string[]) {
    this._daicds = dais;
  }
  changeStaffFilter(staffs: string[]) {
    this._staffcds = staffs;
  }
  getUser!: (daicd: string) => User | undefined;

  getForm(index: number, form: FormArray) {
    return form.at(index) as FormArray;
  }

  compareDate(): void {
    if (this.startDate.invalid || this.endDate.invalid) return;
    // keep zone - picker no need zone change
    const startDate = moment(this.startDate.value).startOf('date');
    const endDate = moment(this.endDate.value).endOf('date');

    if (!startDate && !endDate) return;

    if (!startDate || !endDate) {
      this.dateRange.setErrors({ compareDate: true });
      return;
    }

    if (startDate.isAfter(endDate)) {
      this.dateRange.setErrors({ compareDate: true });
    }
  }
  reset() {
    // set if init config or clear config
    this.isClear = true;
    const timeSpan = this.menuConfig.initDaySpan;
    let config = this.defaultKirokuSetting({ pickupFlag: false, timeSpan, screen: this.currentMenu });
    if (this.currentMenu === KirokuMenu.HITORIBUNNO) {
      config.daicds = this.stateConfig.daicds;
    }
    this._config = config;
    this.emptyConfig();
  }

  defaultKirokuSetting = (init: { pickupFlag: boolean, timeSpan: number, screen: string | KirokuMenu }): KirokuSetting => {
    const { timeSpan, pickupFlag, screen } = init;
    const initDate = moment().startOf(unitOfTime);
    let sdate: moment.Moment = initDate.clone();
    let edate: moment.Moment = initDate.clone().endOf(unitOfTime);
    if (timeSpan < 0) {
      edate = initDate.clone().endOf(unitOfTime);
      sdate = initDate.clone().subtract(Math.abs(timeSpan), unitOfSpan).startOf(unitOfTime)
    } else {
      sdate = initDate.clone()
      edate = initDate.clone().add(timeSpan, unitOfSpan).endOf(unitOfTime)
    }
    const payload: KirokuSetting = {
      daicds: [],
      ttl: [],
      sdate: sdate.format(timeFormat),
      edate: edate.format(timeFormat),
      pickupflg: pickupFlag,
      screen,
      isInit: true
    }
    return payload;
  }

  onSubmit() {
    const { dateRange, keyword, pickupflg } = this.form.value;
    const { sdate, edate } = dateRange;
    const kirokuTag = this.kirokuTagList.map((titleSet, i) =>
      this.selectedAllKiroku ? titleSet.titles : titleSet.titles.filter((_, j) => !!this.kirokuTagForm.value[i][j])
    );
    const chouhyoTag = this.chouhyoTagList.map((titleSet, i) =>
      this.selectedAllChouhyo ? titleSet.titles : titleSet.titles.filter((_, j) => !!this.chouhyoTagForm.value[i][j])
    );
    const records = [...kirokuTag, ...chouhyoTag];
    const ttl = records.flat().map((ttl) => {
      const { ttlkbn, ttlcd } = ttl;
      return [ttlkbn, ttlcd].join('-')
    });
    const ttlnames = records.flat().map((ttl) => {
      const { ttlnm } = ttl;
      return ttlnm
    });
    const keywords = (keyword as string)?.split(' ').filter(x => x != '') || [];
    let _config: KirokuSetting = {
      sdate: '',
      edate: '',
      screen: ''
    };
    if (this.isAredasite) {
      _config = {
        ...this._config,
        sdate: moment(sdate).startOf(unitOfTime).format(timeFormat),
        edate: moment(edate).endOf(unitOfTime).format(timeFormat),
        keyword: keywords,
        pickupflg,
        ttl,
        daicds: this._daicds || [],
        stfcds: this._staffcds || [],
        ttlnames,
        recordType: 2,
        isInit: false,
        recently: false,
        screen: MENU_KIDS.AREDASITE,
        officeOnly: this._config.officeOnly || false
      }
    } else {
      _config = {
        ...this._config,
        sdate: moment(sdate).startOf(unitOfTime).format(timeFormat),
        edate: moment(edate).endOf(unitOfTime).format(timeFormat),
        keyword: keywords,
        pickupflg,
        ttl,
        daicds: this._daicds || [],
        stfcds: this._staffcds || [],
        ttlnames,
        isInit: false,
        recordType: 0,
        recently: false,
        screen: this._config.screen,
        officeOnly: this._config.officeOnly || false
      }
    }

    if (this.isClear) {
      _config.officeOnly = false;
    }
    this.store.dispatch([
      new SetKirokuSetting(_config, KirokuMenu.KIROKUKENSAKU),
      new TriggerHistory()
    ]);
    this.close();
  }

  public close() {
    if (this.isKIROKUKENSAKU) {
      this.router.navigate(['', { outlets: { edit: null } }], { replaceUrl: true });
      return
    }
    history.back();
  }

  get kirokuTagForm() {
    return this.form.get('kirokuTag') as FormArray;
  }
  get chouhyoTagForm() {
    return this.form.get('chouhyoTag') as FormArray;
  }

  cancel() {
    this.store.dispatch(new CancelHandler());
    if (this.isKIROKUKENSAKU && this.stateConfig.isInit) {
      this.webviewService.nativeGoBack();
    }
    history.back();
  }
}

const getUser = (userList: User[]) => {
  return (daicd: string) => userList.find((user) => user.daicd === daicd);
};
